import React, { useMemo } from "react";
// import AdminPurchasedOrder from "../AdminPurchasedOrder";
import { getLanguage } from "../../utils/LocaleUtil";
import { useTimeSince } from "../../utils/dateUtils";
import styles from "./adminPurchasedOrders.module.scss";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
//import { styled } from '@mui/material/styles';
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
//import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/Constant";
import { routeFormatter } from "../../utils/Formatter";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Filter from "../Filter";
import AdminPurchasedOrderCompact from "../AdminPurchasedOrderCompact";

// import { DataGrid, GridToolbar,   GridPagination, } from '@mui/x-data-grid';
// import { DataGridPro, GridColumns, GridRowsProp } from '@mui/x-data-grid-pro';
// import LinearProgress from '@mui/material/LinearProgress';
// import { TableVirtuoso } from 'react-virtuoso';

const AdminPurchasedOrders = (props) => {
  const { t } = useTranslation();
  const { dateFormatter } = useTimeSince();
  const { ordersDetails, allowFiltering = false } = props;

  const columns = [
    // {
    //   width: 100,
    //   minWidth: 100,
    //   label: t("order.expand"),
    //   dataKey: 'id',
    //    field: 'id',
    //    id:'id',
    //    headerName: t("order.expand"),
    //    description: 'Expand',
    //    sortable: true,
    //   //numeric: true,
    // },
    {
      width: 200,
      minWidth: 200,
      label: t("order.ordered_on"),
      id: "orderDate",
      dataKey: "orderDate",
      field: "orderDate",
      headerName: t("order.ordered_on"),
      description: "Order date",
      sortable: true,

      //numeric: true,
    },
    // {
    //   width: 100,
    //   minWidth: 100,
    //   label: t("order.type.title"),
    //   id: "orderType",
    //   dataKey: "orderType",
    //   field: "orderType",
    //   headerName: t("order.type.title"),
    //   description: "Order type",
    //   sortable: false,
    //   align: "center",
    //   //numeric: true,
    // },
    {
      width: 100,
      minWidth: 100,
      label: t("order.project_number"),
      id: "projectNumber",
      dataKey: "projectNumber",
      field: "projectNumber",
      headerName: t("order.project_number"),
      description: "The techpack project number",
      sortable: true,
      align: "center",
      //numeric: true,
    },
    {
      width: 160,
      minWidth: 160,
      label: t("order.customer"),
      id: "userInfo",
      dataKey: "userInfo",
      field: "userInfo",
      headerName: t("order.customer"),
      description: "Name and email of customer",
      sortable: true,
      align: "center",
      //numeric: true,
    },
    {
      width: 200,
      minWidth: 200,
      label: t("order.order_no"),
      id: "orderId",
      dataKey: "orderId",
      field: "orderId",
      headerName: t("order.order_no"),
      description: "Order Id",
      sortable: false,
      align: "center",
    },
    {
      width: 120,
      minWidth: 120,
      label: t("order.status.title"),
      id: "orderStatus",
      dataKey: "orderStatus",
      field: "orderStatus",
      headerName: t("order.status.title"),
      description: "Status",
      sortable: true,
      align: "center",
      //numeric: true,
    },
    // {
    //   width: 120,
    //   minWidth: 120,
    //   label: t("order.number_items"),
    //   id: 'numberOfItems',
    //   dataKey: 'numberOfItems',
    //    field: 'numberOfItems',
    //    headerName: t("order.number_items"),
    //    description: 'Number of items (not number of pieces)',
    //    sortable: false,
    //   //numeric: true,
    // },
  ];

  const rows = useMemo(() => {
    const dateTimeOptions = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // timeZoneName: "short",
    };

    return ordersDetails.map((orderDetail) => {
      let orderId = null;
      if (orderDetail.type === "preorder") {
        orderId = orderDetail.details.preorder.id;
      } else {
        orderId = orderDetail.details.order.id;
      }

      const techpackProjectNumber =
        orderDetail.details?.techpack?.project_number ||
        t("order.not_yet_assigned");

      let orderDate = null;
      if (orderDetail.type === "preorder") {
        orderDate = dateFormatter(
          orderDetail.details.preorder.created_at
        ).toLocaleDateString(getLanguage(), dateTimeOptions);
      } else {
        orderDate = dateFormatter(
          orderDetail.details.order.created_at
        ).toLocaleDateString(getLanguage(), dateTimeOptions);
      }

      const orderStatus = t(
        `preorder.status.options.${orderDetail.details.preorder?.status}`
      );

      const userInfo = `${orderDetail.details.user.first_name} ${orderDetail.details.user.last_name} (${orderDetail.details.user.email})`;

      //Because of legacy when we weren't using purchasedItems, we have to use cartItems
      let numberOfItems = 0;
      if (orderDetail.details.purchasedItems) {
        numberOfItems = orderDetail.details.purchasedItems.length;
      } else {
        numberOfItems = orderDetail.details.cartItems.length;
      }

      return {
        id: orderId,
        userInfo,
        orderId,
        orderDate,
        orderStatus,
        orderType: t(`order.type.${orderDetail.type}`),
        projectNumber: techpackProjectNumber,
        numberOfItems,
        orderDetail: orderDetail,
      };
    });
  }, [ordersDetails, dateFormatter, t]);

  //console.debug("!!!rows", rows);

  // const StyledTableRow = styled(TableRow)(({ theme }) => ({
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  //   // hide last border
  //   '&:last-child td, &:last-child th': {
  //     border: 0,
  //   },
  // }));

  // const TableRowStyled = styled(TableRow)`
  //   &:nth-of-type(odd) {
  //     background-color: #DDDDDD;
  //   }
  //   &:nth-of-type(even) {
  //     background-color: #999999;
  //   }
  //   & > td {
  //     color: white;
  //   }
  // `;

  function CollapsibleRow(props) {
    const { row, columns } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell key="id" padding={"none"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          {columns.map((column) => {
            const value = row[column.id];
            return (
              <TableCell key={column.id} align={column.align} padding={"none"}>
                {column.format && typeof value === "number"
                  ? column.format(value)
                  : value}
              </TableCell>
            );
          })}
          <TableCell key="techpack">
            {row.orderDetail.type === "order" &&
              row.orderDetail.details.techpack && (
                <Link
                  to={routeFormatter(ROUTES.ADMIN_TECHPACK_ORDER, {
                    params: { orderId: row.orderDetail.details.order.id },
                  })}
                  key={row.orderDetail.details.order.id}
                >
                  {t("order.actions.go_to_techpack")}
                </Link>
              )}
            {row.orderDetail.type === "preorder" &&
              row.orderDetail.details.techpack && (
                <Link
                  to={routeFormatter(ROUTES.ADMIN_TECHPACK_PREORDER, {
                    params: { preorderId: row.orderDetail.details.preorder.id },
                  })}
                  key={row.orderDetail.details.preorder.id}
                >
                  {t("order.actions.go_to_techpack")}
                </Link>
              )}
          </TableCell>
          <TableCell key="preorder">
            {row.orderDetail.type === "preorder" && row.orderDetail.details && (
              <Link
                to={routeFormatter(ROUTES.ADMIN_PREORDER, {
                  params: { preorderId: row.orderDetail.details.preorder.id },
                })}
                key={row.orderDetail.details.preorder.id}
              >
                {t("order.actions.go_to_preorder")}
              </Link>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={columns.length + 3}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ marginTop: 2 }}>
                <AdminPurchasedOrderCompact
                  orderDetail={row.orderDetail.details}
                  type={row.orderDetail.type}
                />
                {/*{row.orderDetail.type === "order" ? (*/}
                {/*  <AdminPurchasedOrder*/}
                {/*    type={row.orderDetail.type}*/}
                {/*    orderDetail={row.orderDetail.details}*/}
                {/*    key={row.orderDetail.details.order.id}*/}
                {/*    shouldStartExpanded={true}*/}
                {/*  />*/}
                {/*) : (*/}
                {/*  <AdminPurchasedOrder*/}
                {/*    type={row.orderDetail.type}*/}
                {/*    orderDetail={row.orderDetail.details}*/}
                {/*    key={row.orderDetail.details.preorder.id}*/}
                {/*    shouldStartExpanded={true}*/}
                {/*  />*/}
                {/*)}*/}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function CollapsibleTable() {
    return (
      <TableContainer sx={{ height: "100%" }} component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                key="id"
                align={"left"}
                style={{ minWidth: 50, backgroundColor: "#d6e4f1" }}
              >
                {""}
              </TableCell>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || "center"}
                  style={{
                    minWidth: column.minWidth,
                    backgroundColor: "#d6e4f1",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell
                colSpan={2}
                key="actions"
                align={"center"}
                style={{ minWidth: 50, backgroundColor: "#d6e4f1" }}
              >
                {t("order.actions.title")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <CollapsibleRow key={row.id} row={row} columns={columns} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  // const VirtuosoTableComponents = {
  //   Scroller: React.forwardRef((props, ref) => (
  //     <TableContainer component={Paper} {...props} ref={ref} />
  //   )),
  //   Table: (props) => (
  //     <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} /*size="small"*/ />
  //   ),
  //   TableHead,
  //   TableRow: ({ item: _item, ...props }) => <TableRow {...props} sx={{ cursor: 'pointer' }} hover/>,
  //   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  // };

  // function fixedHeaderContent() {
  //   return (
  //     <TableRow>
  //       {columns.map((column) => (
  //         <TableCell
  //           key={column.dataKey}
  //           variant="head"
  //           align={'left'}
  //           style={{ width: column.width }}
  //           sx={{
  //             backgroundColor: 'background.paper',
  //           }}
  //         >
  //           {column.label}
  //         </TableCell>
  //       ))}
  //     </TableRow>
  //   );
  // }

  // function rowContent(_index, row) {
  //   return (
  //     <React.Fragment>
  //       {columns.map((column) => (
  //         <TableCell
  //           key={column.dataKey}
  //           align={'left'}
  //         >
  //           {row[column.dataKey]}
  //         </TableCell>
  //       ))}
  //     </React.Fragment>
  //   );
  // }

  // const getDetailPanelContent = React.useCallback(
  //   ({ row }) => <div >Je suis un detail!</div>,
  //   [],
  // );

  // const getDetailPanelHeight = React.useCallback(() => 400, []);

  return (
    <div className={styles.container}>
      {allowFiltering && <Filter />}
      <Paper style={{ height: "80vh", width: "100%" }}>
        <CollapsibleTable />
        {/* <TableVirtuoso
            data={rows}
            components={VirtuosoTableComponents}
            fixedHeaderContent={fixedHeaderContent}
            itemContent={rowContent}
          /> */}
        {/* <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            density={"comfortable"}
            //pageSizeOptions={[25,50, 100]}
            //checkboxSelection
            disableRowSelectionOnClick
            //hideFooterPagination
            pagination
            slots={{ 
              toolbar: GridToolbar,
              //loadingOverlay: LinearProgress,
              //pagination: GridPagination
            }}
            //loading={isLoading}
            rowThreshold={0}
          /> */}
      </Paper>
    </div>
  );
};

export default AdminPurchasedOrders;
